import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  from {
    transform: translateY(1000px);
  }
  to {
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  /* @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2000;
    .my-location-container {
      bottom: 68px;
    }
  } */
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    /* background-color: lightcoral;
    position: fixed;
    top: 178px;
    height: calc(100vh - 278px);
    z-index: 2000;
    width: 100vw;
    > div {
      overflow-y: auto;
      height: 100%;
    } */
    position: fixed;
    background-color: ${({ theme }) => theme.colors.shades[0]};
    width: 100%;
    height: calc(100% - 226px);
    box-sizing: border-box;
    /* padding: ${({ theme }) => theme.spacing * 4}px; */
    z-index: 1000;
    &.open {
      animation: ${slideUp} 0.3s ease-in-out forwards;
    }
  }
`;


export const HeaderContainer = styled.div`
  /* @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    background-color: ${({ theme }) => theme.colors.shades[0]};
    width: 100vw;
    padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
  } */
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    /* position: fixed;
    bottom: 0;
    z-index: 2000;
    background-color: ${({ theme }) => theme.colors.shades[0]};
    width: 100vw;
    padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px; */
    display: flex;
    align-items: center;
    padding: 0 ${({ theme }) => theme.spacing * 4}px;
    background-color: ${({ theme }) => theme.colors.shades[0]};
    position: relative;
    .detail {
      position: fixed;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      padding: ${({ theme }) => theme.spacing * 4}px;
      border-radius: 6px 6px 0 0;
      z-index: 2000;
      display: grid;
      grid-template-columns: 70px 1fr;
      grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
      background-color: ${({ theme }) => theme.colors.shades[0]};
      width: 100%;
      .avatar-container {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing * 2}px;
        align-items: center;
        .reviews {
          font-size: 10px;
          color: ${({ theme }) => theme.colors.gray[900]};
          text-align: center;
        }
      }
      .user-info {
        background-color: ${({ theme }) => theme.colors.shades[0]};
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing * 2}px;
        justify-content: space-between;
        > div {
          display: flex;
          flex-direction: column;
          gap: ${({ theme }) => theme.spacing}px;
        }
        .address {
          font-size: 12px;
          color: ${({ theme }) => theme.colors.gray[400]};
        }
        .display-name {
          font-size: 16px;
          font-weight: 700;
          color: ${({ theme }) => theme.colors.gray[900]}
        }
      }
    }
  }
`;

export const ListContainer = styled.div`
  /* @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    overflow-y: auto;
    height: calc(100% - 52px);
  } */
`;


export const DetailsHeader = styled.div`
  /* display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme }) => theme.spacing * 2}px;
    .displayName {
      font-size: 16px;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.gray[900]};
    }
  } */
`;
